import { AfterViewInit, Component, DoCheck, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { FormGroup, FormBuilder, Form } from "@angular/forms";
import { Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../service/auth-service/auth.service";
import { sweetAlert } from "../../../utils/swal";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { ServiceZoneService } from "../service-zone-service/service-zone.service";

@Component({
  selector: 'app-service-zone-add',
  templateUrl: './service-zone-add.component.html',
  styleUrls: ['./service-zone-add.component.css']
})
export class ServiceZoneAddComponent implements OnInit {
  serviceZoneForm: FormGroup;
  cityCodeForm: FormGroup
  submitted = false;
  cityCodeSubmitted = false;
  userId = null;
  cityAreaId;
  cityCodeArray = [];

  constructor(
    public authService: AuthService,
    private serviceZone: ServiceZoneService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.params
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((params) => {
      this.cityAreaId = params["id"];
      if(this.cityAreaId){
        this.getCityAreabyId();
      }
    });

    this.serviceZoneForm = this.fb.group({
      name: ["", Validators.required],
      status: ['active', Validators.required],
      cities: [[]]
    });

    this.cityCodeForm = this.fb.group({
      cityCode:['',Validators.required]
    })

  }

  addCity() {
    this.submitted = true;
    this.cityCodeSubmitted = true;
    if (this.cityCodeForm.invalid) {
      return;
    }
    for(let item of this.cityCodeArray){
      this.serviceZoneForm.value.cities.push(item);
    }
    this.cityCodeArray= [];
    this.cityCodeForm.reset();
    this.cityCodeSubmitted = false;
    this.submitted = false;
  }

  removeZipCode(index) {
    const z1 = this.serviceZoneForm.value.cities;
    z1.splice(index, 1);
    this.serviceZoneForm.patchValue({
      cities: z1
    });
  }

  getCityAreabyId(){
    this.serviceZone.getServiceZonebyId(this.cityAreaId)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.serviceZoneForm.patchValue(data)
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "Ok");
      }
    );
  }

  onInputChange(event: any) {
    const inputValue = event.target.value;
    if (inputValue) {
      const values = inputValue.split(',');
       this.cityCodeArray = values.map(value => value.trim());
    }
  }


  saveStaff() {
    this.submitted = true;
    if (this.serviceZoneForm.invalid || this.serviceZoneForm.value.cities.length === 0) {
      this.cityCodeSubmitted = true;
      return;
    } else {
      let payload = this.serviceZoneForm.value;
      this.serviceZone.addServiceZone(payload,this.cityAreaId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.router.navigateByUrl("fleet/cities-zones");
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
    }
  }

  get form() {
    return this.serviceZoneForm.controls;
  }
  get formControl(){
    return this.cityCodeForm.controls;
  }


ngOnDestroy(): void {
}

}
